<template>
  <div class="container-fluid h-100 p-0">
    <div class="row h-100 g-0">
      <!-- Left Side Form -->
      <div class="col-12 col-md-3 col-lg-3 h-100">
        <div
          class="overflow-y-auto h-100 pt-4 px-3"
          style="height: calc(100vh - 60px)"
        >
          <!-- Battery Section -->
          <section class="mb-3 pb-3 border-bottom">
            <h3 class="mb-3">
              {{ $t("project.batteryAndBackup.title") }}
            </h3>
            

            
            <div v-if="isLoading" class="text-center py-3">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{
                  $t("project.batteryAndBackup.loading")
                }}</span>
              </div>
            </div>
            <div v-else-if="error" class="alert alert-danger">
              {{ error }}
            </div>
            <div
              v-else
              v-for="(battery, index) in batteries"
              :key="'battery-' + index"
              class="battery-config position-relative"
            >

              
              <button
                v-if="batteries.length > 1"
                @click="removeBattery(index)"
                class="btn btn-close position-absolute"
                style="right: 10px; top: 10px"
                aria-label="Delete battery"
              ></button>
              <div class="mb-3">
                <label class="form-label">{{
                  $t("project.batteryAndBackup.batteryModel")
                }}</label>
                <select v-model="battery.device_id" class="form-select">
                  <option value="">
                    {{ $t("project.batteryAndBackup.selectModel") }}
                  </option>
                  <option
                    v-for="battery in equipmentStore.batteries"
                    :key="battery.id"
                    :value="battery.id"
                  >
                    {{ battery.manufacturer }} {{ battery.model_number }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">{{
                  $t("project.batteryAndBackup.numberOfUnits")
                }}</label>
                <input
                  type="number"
                  v-model="battery.pcs"
                  class="form-control"
                  min="1"
                />
              </div>
              <button
                v-if="index === batteries.length - 1"
                @click="addBattery"
                class="btn btn-outline-primary btn-sm"
              >
                {{ $t("project.batteryAndBackup.addAnotherBattery") }} +
              </button>
              

            </div>
          </section>

          <!-- EV Charger Section -->
          <section class="mb-3 pb-3">
            <h3 class="mb-3">
              {{ $t("project.batteryAndBackup.evTitle") }}
            </h3>
            <div v-if="isLoading" class="text-center py-3">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{
                  $t("project.batteryAndBackup.loading")
                }}</span>
              </div>
            </div>
            <div v-else-if="error" class="alert alert-danger">
              {{ error }}
            </div>
            <div
              v-else
              v-for="(charger, index) in evChargers"
              :key="'charger-' + index"
              class="ev-charger-config position-relative"
            >
              <button
                v-if="evChargers.length > 1"
                @click="removeCharger(index)"
                class="btn btn-close position-absolute"
                style="right: 10px; top: 10px"
                aria-label="Delete charger"
              ></button>
              <div class="mb-3">
                <label class="form-label">{{
                  $t("project.batteryAndBackup.evChargerModel")
                }}</label>
                <select v-model="charger.device_id" class="form-select">
                  <option value="">
                    {{ $t("project.batteryAndBackup.selectModel") }}
                  </option>
                  <option
                    v-for="charger in equipmentStore.evChargers"
                    :key="charger.id"
                    :value="charger.id"
                  >
                    {{ charger.manufacturer }} {{ charger.model_number }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">{{
                  $t("project.batteryAndBackup.numberOfUnits")
                }}</label>
                <input
                  type="number"
                  v-model="charger.pcs"
                  class="form-control"
                  min="1"
                />
              </div>
              <button
                v-if="index === evChargers.length - 1"
                @click="addCharger"
                class="btn btn-outline-primary btn-sm"
              >
                {{ $t("project.batteryAndBackup.addAnotherCharger") }} +
              </button>
            </div>
          </section>

          <!-- Meter Section -->
          <section class="mb-3 pb-3">
            <h3 class="mb-3">
              {{ $t("project.batteryAndBackup.meterTitle") }}
            </h3>
            <div v-if="isLoading" class="text-center py-3">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{
                  $t("project.batteryAndBackup.loading")
                }}</span>
              </div>
            </div>
            <div v-else-if="error" class="alert alert-danger">
              {{ error }}
            </div>
            <div
              v-else
              v-for="(meter, index) in meters"
              :key="'meter-' + index"
              class="meter-config position-relative"
            >
              <button
                v-if="meters.length > 1"
                @click="removeMeter(index)"
                class="btn btn-close position-absolute"
                style="right: 10px; top: 10px"
                aria-label="Delete meter"
              ></button>
              <div class="mb-3">
                <label class="form-label">{{
                  $t("project.batteryAndBackup.meterModel")
                }}</label>
                <select v-model="meter.device_id" class="form-select">
                  <option value="">
                    {{ $t("project.batteryAndBackup.selectModel") }}
                  </option>
                  <option
                    v-for="meterModel in equipmentStore.meters"
                    :key="meterModel.id"
                    :value="meterModel.id"
                  >
                    {{ meterModel.manufacturer }} {{ meterModel.model_number }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">{{
                  $t("project.batteryAndBackup.numberOfUnits")
                }}</label>
                <input
                  type="number"
                  v-model="meter.pcs"
                  class="form-control"
                  min="1"
                />
              </div>
              <button
                v-if="index === meters.length - 1"
                @click="addMeter"
                class="btn btn-outline-primary btn-sm"
              >
                {{ $t("project.batteryAndBackup.addAnotherMeter") }} +
              </button>
            </div>
          </section>
        </div>
      </div>

      <!-- Right Side Empty Area -->
      <div class="col-12 col-md-9 col-lg-9 h-100 d-none d-md-block p-4">
        <div
          class="position-fixed h-100"
          style="top: 90px; left: 33%; right: 10px"
        >
          <div class="h-85 bg-white shadow-sm p-4" style="border-radius: 2px">
            <div class="schematic-container position-relative h-100">
              <!-- Solar Panels -->
              <div class="component-box solar-panels">
                <i class="bi bi-file-plus"></i>
                <div class="component-label">
                  <div class="fw-bold">
                    {{ $t("project.batteryAndBackup.components.solarPanels") }}
                  </div>
                  <div class="small text-muted">
                    {{ getSelectedPanelsInfo }}
                  </div>
                </div>
              </div>

              <!-- Power Flow Arrow -->
              <div class="power-flow-arrow solar-to-inverter">
                <i class="bi bi-arrow-down"></i>
              </div>

              <!-- Inverter -->
              <div class="component-box inverter">
                <i class="bi bi-device-ssd"></i>
                <div class="component-label">
                  <div class="fw-bold">
                    {{ $t("project.batteryAndBackup.components.inverter") }}
                  </div>
                  <div class="small text-muted">
                    {{ getSelectedInvertersInfo }}
                  </div>
                </div>
              </div>

              <!-- Inverter to Batteries Power Flow -->
              <div class="power-flow-arrow inverter-to-batteries">
                <i class="bi bi-arrow-down-up"></i>
              </div>

              <!-- Inverter to EV Charger Power Flow -->
              <div class="power-flow-arrow inverter-to-ev">
                <i class="bi bi-arrow-left"></i>
              </div>

              <!-- EV Charger -->
              <div class="component-box ev-charger">
                <i class="bi bi-ev-station"></i>
                <div class="component-label">
                  <div class="fw-bold">
                    {{ $t("project.batteryAndBackup.components.evCharger") }}
                  </div>
                  <div class="small text-muted">
                    {{ getSelectedEVChargersInfo }}
                  </div>
                </div>
              </div>

              <!-- Grid -->
              <div class="component-box grid">
                <i class="bi bi-plug"></i>
                <div class="component-label">
                  <div class="fw-bold">
                    {{ $t("project.batteryAndBackup.components.grid") }}
                  </div>
                  <div class="small text-muted">
                    {{ $t("project.batteryAndBackup.components.powerGrid") }}
                  </div>
                </div>
              </div>

              <!-- Grid-Inverter Power Flow -->
              <div class="power-flow-arrow grid-to-inverter">
                <i class="bi bi-arrow-left-right"></i>
              </div>

              <!-- Batteries -->
              <div class="component-box batteries">
                <i class="bi bi-battery-half"></i>
                <div class="component-label">
                  <div class="fw-bold">
                    {{ $t("project.batteryAndBackup.components.batteries") }}
                  </div>
                  <div class="small text-muted">
                    {{ getSelectedBatteriesInfo }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile View -->
      <div class="col-12 d-md-none p-4" style="height: 250px">
        <div class="h-85 bg-white shadow-sm p-4" style="border-radius: 2px">
          <div class="schematic-container position-relative h-100">
            <!-- Mobile version of the schematic -->
            <div class="text-center text-muted">
              {{ $t("project.batteryAndBackup.mobileViewMessage") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, watch } from "vue";
import { useEquipmentStore } from "@/stores/equipment";
import { useProjectStore } from "@/stores/project";
import { storeToRefs } from "pinia";
import type { ProjectDevice } from "@/types/projectTypes";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "ProjectBatteryAndBackupComponent",
  components: {},
  emits: ["back", "next"],
  setup() {
    const { t } = useI18n();
    const equipmentStore = useEquipmentStore();
    const projectStore = useProjectStore();
    const { project } = storeToRefs(projectStore);

    // Use ProjectDevice instead of separate interfaces
    const batteries = ref<Partial<ProjectDevice>[]>([
      { device_type: "Battery", pcs: 1 },
    ]);
    const evChargers = ref<Partial<ProjectDevice>[]>([
      { device_type: "EVCharger", pcs: 1 },
    ]);
    const meters = ref<Partial<ProjectDevice>[]>([
      { device_type: "Meter", pcs: 1 },
    ]);

    // Flag to prevent recursive updates
    const isUpdatingFromProject = ref(false);

    // Computed properties for loading and error states
    const isLoading = computed(() => equipmentStore.isLoading);
    const error = computed(() => equipmentStore.error);

    // Initialize from existing project data if available
    onMounted(() => {
      const loadDevices = () => {
        if (project.value?.devices) {
          // Load existing batteries
          const existingBatteries = project.value.devices
            .filter((device) => device.device_type === "Battery")
            .map((device) => ({
              device_type: "Battery",
              device_id: device.device_id,
              pcs: device.pcs,
            }));

          batteries.value =
            existingBatteries.length > 0
              ? existingBatteries
              : [{ device_type: "Battery", pcs: 1 }];

          // Load existing EV chargers
          const existingEVChargers = project.value.devices
            .filter((device) => device.device_type === "EVCharger")
            .map((device) => ({
              device_type: "EVCharger",
              device_id: device.device_id,
              pcs: device.pcs,
            }));

          evChargers.value =
            existingEVChargers.length > 0
              ? existingEVChargers
              : [{ device_type: "EVCharger", pcs: 1 }];

          // Load existing meters
          const existingMeters = project.value.devices
            .filter((device) => device.device_type === "Meter")
            .map((device) => ({
              device_type: "Meter",
              device_id: device.device_id,
              pcs: device.pcs,
            }));

          meters.value =
            existingMeters.length > 0
              ? existingMeters
              : [{ device_type: "Meter", pcs: 1 }];
        }
      };

      // Ensure equipment data is loaded
      if (equipmentStore.batteries.length === 0) {
        console.log("No batteries found, fetching equipment data...");
        equipmentStore.fetchEquipment().then(() => {
          console.log("Equipment data loaded:", {
            batteries: equipmentStore.batteries,
            evChargers: equipmentStore.evChargers,
          });
          loadDevices();
        });
      } else {
        console.log("Existing equipment data:", {
          batteries: equipmentStore.batteries,
          evChargers: equipmentStore.evChargers,
        });
        loadDevices();
      }
    });

    const addBattery = () => {
      batteries.value.push({ device_type: "Battery", pcs: 1 });
    };

    const removeBattery = (index: number) => {
      batteries.value.splice(index, 1);
    };

    const addCharger = () => {
      evChargers.value.push({ device_type: "EVCharger", pcs: 1 });
    };

    const removeCharger = (index: number) => {
      evChargers.value.splice(index, 1);
    };

    const addMeter = () => {
      meters.value.push({ device_type: "Meter", pcs: 1 });
    };

    const removeMeter = (index: number) => {
      meters.value.splice(index, 1);
    };

    // Helper function to create a ProjectDevice
    const createDevice = (
      type: "Battery" | "EVCharger" | "Meter",
      deviceId: number,
      count: number
    ): ProjectDevice | null => {
      if (!project.value) return null;

      
      return {
        project: project.value.id,
        device_type: type,
        device_id: deviceId,
        pcs: count,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      };
    };

    // Helper function to update devices in project store
    const updateDevices = () => {
      if (!project.value) return;

      const batteryDevices = batteries.value
        .filter((b) => b.device_id && b.pcs && b.pcs > 0)
        .map((b) => createDevice("Battery", b.device_id!, b.pcs!))
        .filter((device): device is ProjectDevice => device !== null);

      const evChargerDevices = evChargers.value
        .filter((e) => e.device_id && e.pcs && e.pcs > 0)
        .map((e) => createDevice("EVCharger", e.device_id!, e.pcs!))
        .filter((device): device is ProjectDevice => device !== null);

      const meterDevices = meters.value
        .filter((m) => m.device_id && m.pcs && m.pcs > 0)
        .map((m) => createDevice("Meter", m.device_id!, m.pcs!))
        .filter((device): device is ProjectDevice => device !== null);

      // Get existing devices that are not batteries, EV chargers, or meters
      const otherDevices = project.value.devices.filter(
        (device) =>
          device.device_type !== "Battery" && 
          device.device_type !== "EVCharger" && 
          device.device_type !== "Meter"
      );

      // Combine all devices and update project store
      const allDevices = [
        ...otherDevices,
        ...batteryDevices,
        ...evChargerDevices,
        ...meterDevices,
      ];
      projectStore.setProjectDevices(allDevices);
    };

    // Watch for changes in batteries, EV chargers, and meters
    watch(
      [batteries, evChargers, meters],
      () => {
        if (!isUpdatingFromProject.value) {
          // Only update project store when we have actual device selections
          // This prevents empty items from being synced
          const hasValidDevices = batteries.value.some(b => b.device_id) ||
                                 evChargers.value.some(e => e.device_id) ||
                                 meters.value.some(m => m.device_id);
          
          if (hasValidDevices) {
            updateDevices();
          }
        }
      },
      { deep: true }
    );

    // Watch for changes in project devices (e.g., when a kit is selected)
    // This should only trigger for external changes, not local updates
    watch(
      () => project.value?.devices,
      (newDevices, oldDevices) => {
        // Only reload if this is an external change (like kit selection)
        // and not a change we just made
        if (newDevices && oldDevices && !isUpdatingFromProject.value) {
          // Check if this is an external change by comparing device counts
          const oldBatteryCount = oldDevices.filter(d => d.device_type === "Battery").length;
          const oldEVChargerCount = oldDevices.filter(d => d.device_type === "EVCharger").length;
          const oldMeterCount = oldDevices.filter(d => d.device_type === "Meter").length;
          
          const newBatteryCount = newDevices.filter(d => d.device_type === "Battery").length;
          const newEVChargerCount = newDevices.filter(d => d.device_type === "EVCharger").length;
          const newMeterCount = newDevices.filter(d => d.device_type === "Meter").length;
          
          // Only reload if this is a significant external change
          const isExternalChange = 
            Math.abs(newBatteryCount - oldBatteryCount) > 0 ||
            Math.abs(newEVChargerCount - oldEVChargerCount) > 0 ||
            Math.abs(newMeterCount - oldMeterCount) > 0;
            
          if (isExternalChange) {
            isUpdatingFromProject.value = true;
            
            // Reload arrays from project store
            const existingBatteries = newDevices
              .filter((device) => device.device_type === "Battery")
              .map((device) => ({
                device_type: "Battery",
                device_id: device.device_id,
                pcs: device.pcs,
              }));

            const existingEVChargers = newDevices
              .filter((device) => device.device_type === "EVCharger")
              .map((device) => ({
                device_type: "EVCharger",
                device_id: device.device_id,
                pcs: device.pcs,
              }));

            const existingMeters = newDevices
              .filter((device) => device.device_type === "Meter")
              .map((device) => ({
                device_type: "Meter",
                device_id: device.device_id,
                pcs: device.pcs,
              }));

            // Update local arrays
            batteries.value = existingBatteries.length > 0 ? existingBatteries : [{ device_type: "Battery", pcs: 1 }];
            evChargers.value = existingEVChargers.length > 0 ? existingEVChargers : [{ device_type: "EVCharger", pcs: 1 }];
            meters.value = existingMeters.length > 0 ? existingMeters : [{ device_type: "Meter", pcs: 1 }];

            // Reset the flag
            setTimeout(() => {
              isUpdatingFromProject.value = false;
            }, 100);
          }
        }
      },
      { deep: true }
    );

    // Computed properties for component info
    const getSelectedPanelsInfo = computed(() => {
      if (!project.value?.devices)
        return t("project.batteryAndBackup.none.panels");
      const panelDevices = project.value.devices.filter(
        (d) => d.device_type === "Panel"
      );
      if (panelDevices.length === 0)
        return t("project.batteryAndBackup.none.panels");

      return panelDevices
        .map((device) => {
          const panel = equipmentStore.panels.find(
            (p) => p.id === device.device_id
          );
          return `${panel?.manufacturer} ${panel?.model_number} (${device.pcs})`;
        })
        .join("\n");
    });

    const getSelectedInvertersInfo = computed(() => {
      if (!project.value?.devices)
        return t("project.batteryAndBackup.none.inverters");
      const inverterDevices = project.value.devices.filter(
        (d) => d.device_type === "Inverter"
      );
      if (inverterDevices.length === 0)
        return t("project.batteryAndBackup.none.inverters");

      return inverterDevices
        .map((device) => {
          const inverter = equipmentStore.inverters.find(
            (i) => i.id === device.device_id
          );
          return `${inverter?.manufacturer} ${inverter?.model_number} (${device.pcs})`;
        })
        .join("\n");
    });

    const getSelectedBatteriesInfo = computed(() => {
      if (!project.value?.devices)
        return t("project.batteryAndBackup.none.batteries");
      const batteryDevices = project.value.devices.filter(
        (d) => d.device_type === "Battery"
      );
      if (batteryDevices.length === 0)
        return t("project.batteryAndBackup.none.batteries");

      return batteryDevices
        .map((device) => {
          const battery = equipmentStore.batteries.find(
            (b) => b.id === device.device_id
          );
          return `${battery?.manufacturer} ${battery?.model_number} (${device.pcs})`;
        })
        .join("\n");
    });

    const getSelectedEVChargersInfo = computed(() => {
      if (!project.value?.devices)
        return t("project.batteryAndBackup.none.evChargers");
      const evChargerDevices = project.value.devices.filter(
        (d) => d.device_type === "EVCharger"
      );
      if (evChargerDevices.length === 0)
        return t("project.batteryAndBackup.none.evChargers");

      return evChargerDevices
        .map((device) => {
          const evCharger = equipmentStore.evChargers.find(
            (e) => e.id === device.device_id
          );
          return `${evCharger?.manufacturer} ${evCharger?.model_number} (${device.pcs})`;
        })
        .join("\n");
    });

    const getSelectedMetersInfo = computed(() => {
      if (!project.value?.devices)
        return t("project.batteryAndBackup.none.meters");
      const meterDevices = project.value.devices.filter(
        (d) => d.device_type === "Meter"
      );
      if (meterDevices.length === 0)
        return t("project.batteryAndBackup.none.meters");

      return meterDevices
        .map((device) => {
          const meter = equipmentStore.meters.find(
            (m) => m.id === device.device_id
          );
          return `${meter?.manufacturer} ${meter?.model_number} (${device.pcs})`;
        })
        .join("\n");
    });

    return {
      batteries,
      addBattery,
      removeBattery,
      evChargers,
      addCharger,
      removeCharger,
      meters,
      addMeter,
      removeMeter,
      isLoading,
      error,
      equipmentStore,
      getSelectedPanelsInfo,
      getSelectedInvertersInfo,
      getSelectedBatteriesInfo,
      getSelectedEVChargersInfo,
      getSelectedMetersInfo,
    };
  },
});
</script>

<style scoped>
.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: var(--color-light-gray);
  border-radius: 2px;
}

@media (max-width: 768px) {
  .container-fluid {
    padding-left: 60px; /* Account for fixed sidebar on mobile */
  }
}

.form-control {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
}

.form-control:focus {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.battery-config,
.ev-charger-config,
.meter-config {
  padding: 15px;
  margin-bottom: 15px;
  background-color: var(--color-light-light-gray);
  border-radius: 2px;
}



.form-label {
  font-weight: 500;
  color: var(--color-dark);
}

.btn-outline-primary {
  width: 70%;
  margin-top: 10px;
  margin-left: auto;
  display: block;
  border-radius: 2px;
  color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  background-color: transparent !important;
}

.btn-outline-primary:hover {
  color: var(--color-white) !important;
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}

.btn-primary {
  width: 100%;
  margin-top: 20px;
}

.h-85 {
  height: 85%;
  background-color: var(--color-light);
  border-radius: 2px;
}

.schematic-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-white);
}

.component-box {
  position: absolute;
  width: 192px;
  height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 20px;
  background-color: var(--color-white);
  border: 1px solid var(--color-light-gray);
  border-radius: 2px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.component-box i {
  font-size: 2rem;
  margin-bottom: 4px;
  color: var(--primary-color);
}

.component-label {
  position: relative;
  text-align: center;
  width: 95%;
}

.component-label .fw-bold {
  display: block;
  font-size: 0.9rem;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--color-light-gray);
  margin-bottom: 4px;
}

.component-label .small {
  display: block;
  font-size: 0.7rem;
  color: var(--color-gray);
  line-height: 1.2;
  white-space: pre-line;
}

/* Component Positions */
.solar-panels {
  top: 2%;
  left: 50%;
  transform: translateX(-50%);
}
.inverter {
  top: 47%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.ev-charger {
  top: 47%;
  left: 5%;
  transform: translateY(-50%);
}
.grid {
  top: 47%;
  right: 5%;
  transform: translateY(-50%);
}
.batteries {
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
}

/* Icons */
.bi {
  color: var(--primary-color);
  margin-bottom: 8px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .component-box {
    width: 180px;
    height: 100px;
  }

  .component-label {
    font-size: 0.8rem;
  }
}

/* Power Flow Arrow */
.power-flow-arrow {
  position: absolute;
  z-index: 2;
  color: var(--color-graph-green);
  font-size: 1rem;
  border-radius: 2px;
}

.power-flow-arrow.solar-to-inverter {
  top: 31%;
  left: 48.5%;
  animation: flowBidirectional 2s infinite;
}

.power-flow-arrow.grid-to-inverter {
  top: 47%;
  left: 65%;
  animation: flowBidirectional 2s infinite;
}

.power-flow-arrow.inverter-to-ev {
  top: 47%;
  left: 33%;
  transform: translateX(100%);
  animation: flowBidirectional 2s infinite;
}

.power-flow-arrow.inverter-to-batteries {
  top: 65%;
  left: 48.5%;
  transform: translateX(-50%);
  animation: flowBidirectional 2s infinite;
}

@keyframes flowDown {
  0% {
    transform: translateX(-50%) translateY(0);
    opacity: 0.3;
  }
  50% {
    transform: translateX(-50%) translateY(10px);
    opacity: 1;
  }
  100% {
    transform: translateX(-50%) translateY(0);
    opacity: 0.3;
  }
}

@keyframes flowBidirectional {
  0% {
    transform: translateY(-50%) scale(1);
    opacity: 0.3;
  }
  50% {
    transform: translateY(-50%) scale(1.1);
    opacity: 1;
  }
  100% {
    transform: translateY(-50%) scale(1);
    opacity: 0.3;
  }
}

.form-select {
  border-radius: 2px;
}

.btn {
  border-radius: 2px;
}

.btn-close {
  border-radius: 2px;
}
</style>
